import api from "crqlar-react-common/dist/services/api";
import type {
    MarketingHealthV4,
    MarketingInterestAudienceV4,
    MarketingLifecycleV4,
} from "../models/marketing-v4";

export class MarketingInsightsV4Service {
    private static baseUrl = "/v3/insights/marketing/v4/overview";

    static async health(): Promise<MarketingHealthV4> {
        const response = await api.get<MarketingHealthV4>(`${MarketingInsightsV4Service.baseUrl}/health`);
        return response.data;
    }

    static async interests(): Promise<MarketingInterestAudienceV4[]> {
        const response = await api.get<MarketingInterestAudienceV4[]>(
            `${MarketingInsightsV4Service.baseUrl}/interests`,
        );
        return response.data;
    }

    static async audiences(): Promise<MarketingLifecycleV4> {
        const response = await api.get<MarketingLifecycleV4>(`${MarketingInsightsV4Service.baseUrl}/audiences`);
        return response.data;
    }
}
